/**
 * Client-side SVG sanitization (defense in depth; API also sanitizes on save).
 */
const XML_DECL_RE = /^\s*<\?xml[\s\S]*?\?>\s*/i
const BLOCKED_TAGS_RE = /<\/?(script|foreignObject|iframe|object|embed|applet|link|meta|style|image|use)\b[^>]*>/gi
const EVENT_ATTR_RE = /\s+on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi
const JS_HREF_RE = /(?:href|xlink:href)\s*=\s*["']?\s*javascript:/gi
const DATA_HTML_RE = /data:\s*text\/html/gi

export function sanitizeSvgMarkup(input) {
    if (!input || typeof input !== "string") {
        return ""
    }

    let svg = input.trim().replace(XML_DECL_RE, "")
    if (!/^<svg[\s>]/i.test(svg)) {
        return ""
    }

    svg = svg
        .replace(BLOCKED_TAGS_RE, "")
        .replace(EVENT_ATTR_RE, "")
        .replace(JS_HREF_RE, "")
        .replace(DATA_HTML_RE, "")

    if (!/^<svg[\s>]/i.test(svg.trim())) {
        return ""
    }

    return svg.trim()
}
